import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/Image/logo.png";
import "./navbar.css";

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
        <img src={Logo} alt="logo" className="logo-img" />
      </Link>

      {/* Mobile Icon */}
      <div className="menu-icon" onClick={handleClick}>
        <i className={click ? "fas fa-times" : "fas fa-bars"} />
      </div>

      {/* Menu */}
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li className="nav-item">
          <Link to="/" className="nav-links" onClick={closeMobileMenu}>
            Home
          </Link>
        </li>

        <li className="nav-item">
          <Link to="/about" className="nav-links" onClick={closeMobileMenu}>
            About
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/programmes"
            className="nav-links"
            onClick={closeMobileMenu}
          >
            Programs
          </Link>
        </li>

        <li className="nav-item">
          <Link to="/gallery" className="nav-links" onClick={closeMobileMenu}>
            Gallery
          </Link>
        </li>

        <li className="nav-item">
          <Link to="/contact" className="nav-links" onClick={closeMobileMenu}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Call Button */}
      <div className="call-btn">
        <a href="tel:+919886003080">📞 Call Now</a>
      </div>
    </nav>
  );
}

export default Navbar;
